import { CSSProperties, Fragment, useMemo } from 'react';
import * as S from './styles';
import Image, { StaticImageData } from 'next/image';
import Text from '../Text';
import { useTheme } from 'styled-components';
import Link from 'next/link';
import useBreakpoint from '@/hooks/useBreakpoint';

export type PlataformaProps = {
  $image?: string | StaticImageData;
  $imageProps?: object;
  $nome?: string;
  $corNome?: string;
  $link?: string;
  $disabled?: boolean;
  $eventoAnalytics: () => void;
  $style?: CSSProperties;
};

export default function Plataforma(props: PlataformaProps) {
  const {
    $image,
    $imageProps = {},
    $nome,
    $corNome,
    $link = '',
    $disabled = false,
    $eventoAnalytics,
    $style,
  } = props;

  const theme = useTheme();
  const { breakpoint } = useBreakpoint();

  const externo = useMemo(() => $link?.includes('http'), [$link]);

  return (
    <S.Container onClick={$eventoAnalytics} style={$style} {...props}>
      <Link href={$link} passHref legacyBehavior>
        <a
          target={externo ? '_blank' : '_self'}
          style={{
            pointerEvents: $disabled ? 'none' : 'auto',
          }}
        >
          <Fragment>
            {$image ? (
              <S.ImageWrapper>
                <Image
                  src={$image}
                  alt={`logo da plataforma ${$nome}`}
                  priority
                  fill
                  sizes="84px"
                  style={{
                    objectFit: 'cover',
                    ...$imageProps,
                  }}
                />
              </S.ImageWrapper>
            ) : null}
            {$nome ? (
              <Text
                $size={breakpoint === 'mobile' ? 2 : 3}
                $color={$corNome || 'neutral'}
                $weight="regular"
                $align="center"
                $highContrast={true}
                $text={$nome}
                style={{ marginTop: theme.spacing[2] }}
              />
            ) : null}
          </Fragment>
        </a>
      </Link>
    </S.Container>
  );
}
